import React, { useEffect, useRef, useState } from 'react';

const ChatBot = () => {
  const iframeRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false)

  const getCookieValue = (name) => {
    return (
      document.cookie.split(';').map(c => c.trim()).find(row => row.startsWith(`${name}=`))?.split('=')[1] || ''
    );
  };

  useEffect(() => {
    const userState = JSON.parse(localStorage.getItem('UserState')) || {};
    const isStaffView = userState?.isStaffView;
    const accessToken = localStorage.getItem('Auth');

    if (!iframeRef.current || !userState || isStaffView) return;

    const userLevel = getCookieValue('studentCurrentLevel')
    const configOptions = {
      userToken: accessToken,
      firstName: userState?.studentFullName,
      currentLevel: userLevel.replace(/\D/g, ''),
      envType: process.env.ENV_TYPE,
      appName: 'wse-dsw-web'
    };
    let timeoutId;
    iframeRef.current.onload = () => {
      timeoutId = setTimeout(() => {
        iframeRef.current?.contentWindow?.postMessage(
          { type: 'INIT_CHATBOT', payload: configOptions },
          new URL(process.env.REACT_APP_CHAT_BOT_API_URL).origin
        );
      }, 500);
    };
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      iframeRef.current.onload = null;
    };
  }, [getCookieValue]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event?.data?.type === 'CHATBOT_TOGGLE') {
        const isOpen = event?.data?.open;
        setIsOpen(!!isOpen)
      }
      if (event?.data?.type === "CLOSE_CHATBOT") {
        if (iframeRef?.current && iframeRef?.current?.contentWindow) {
          iframeRef.current.contentWindow.postMessage(
            { type: 'CLOSE_CHATBOT', open: false },
            '*'
          );
        }
        setIsOpen(false)
      }
    };
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <iframe
      ref={iframeRef}
      src={process.env.REACT_APP_CHAT_BOT_API_URL}
      title="ChatBot"
      style={{
        position: 'fixed',
        bottom: '80px',
        right: '20px',
        width: isOpen ? '400px' : '65px',
        height: isOpen ? '520px' : '95px',
        transition: 'all 0.3s ease',
        border: 'none',
        zIndex: 1000,
        backgroundColor: 'transparent',
        overflow: 'hidden',
        borderRadius: '12px'
      }}
    />
  );
};

export default ChatBot;
